import {Logout} from 'components/User';
import {connect} from 'react-redux';
import {userLogout} from 'actions/user';

const mapDispatchToProps = (dispatch) => ({
    userLogout (persistor) {
    dispatch(userLogout(persistor));
  }
});

export default connect(null, mapDispatchToProps)(Logout);
